// js/api.js
import { Toast } from '../comun/toast.js';

// API propia desde el 31 jul 2026 (tarea 1.8). Antes: n8n.deviant.cl/webhook/admin.
const API_BASE_URL = 'https://api.deviant.cl/admin';
const TIMEOUT_MS = 10000; // 10 segundos, igual que en app.deviant.cl

export async function apiFetch(endpoint, options = {}) {
    const controller = new AbortController();
    // ⚠️ El timeout es configurable porque las altas no son consultas: crear un canal habla con
    // Chatwoot dos veces (el inbox y la regla de automatización) y crear una línea habla con
    // Evolution. Si eso pasa de 10 s, el operador lee «el servidor tardó demasiado» sobre algo que
    // **sí se creó**, y el reintento choca con un identificador ya usado. Un aviso que hace
    // reintentar una operación que ya ocurrió es peor que la espera.
    const timeoutId = setTimeout(() => controller.abort(), options.timeoutMs || TIMEOUT_MS);

    // Bandera de modo silencioso, igual convención que api.js original
    const hideErrorToast = options.hideErrorToast || false;

    // Inyección de headers y token admin
    const token = localStorage.getItem('admin_token');
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            ...options,
            headers,
            signal: controller.signal
        });

        clearTimeout(timeoutId);

        const data = await response.json();

        if (!response.ok) {
            // ⚠️ `mensaje` además de `message`: las rutas de canales (`src/rutas/canales.js`) contestan
            // en castellano como el resto de ese archivo, así que sin este `??` el motivo real
            // —«Falta la casilla de correo», «Chatwoot no pudo crear el canal»— se perdía y el
            // operador leía un «Error HTTP: 400» pelado.
            const err = new Error(data.message ?? data.mensaje ?? `Error HTTP: ${response.status}`);
            err.status = response.status;
            throw err;
        }

        return data;

    } catch (error) {
        clearTimeout(timeoutId);

        if (!hideErrorToast) {
            if (error.name === 'AbortError') {
                Toast.error('Tiempo de espera agotado. El servidor tardó demasiado.');
                console.error('[API] Timeout de 10s alcanzado en:', endpoint);
            } else {
                Toast.error(error.message || 'Ocurrió un error de conexión.');
                console.error('[API] Error:', error.message);
            }
        }

        throw error;
    }
}
